<template>
  <div class="tags" :class="{'tags-hasarrow': showTagArrow}" ref="tagsRef">
    <van-tag size="medium" v-for="(item, index) in tagsArr" :key="index" round color="rgba(238, 55, 33, 0.10)" text-color="#EE3721" ref="vanTagRef">{{ item }}</van-tag>
    <img class="tags-arrow" :class="{ 'show-all-tags': showAlltagsFlag }" src="@/assets/images/parent-course/tags-arrow.png" alt="下拉箭头" v-if="showTagArrow" @click="showAlltags">
  </div>
</template>

<script>
export default {
  props:['tags'],
  data() {
    return {
      showTagArrow: false,
      showAlltagsFlag: false,

      tagsArr: []
    }
  },

  // 计算属性
  computed: {},

  // 数据监听
  watch: {
    tags: {
      handler() {
        if (this.tags) {
          this.tagsArr = this.tags.split(',')
          this.tagsArr = this.tagsArr.filter( item => item != '' )
          this.$nextTick(() => {
            if (this.$refs.tagsRef && this.$refs.vanTagRef) {
              this.handlerIsRows()
            }
          })
        }
      },
      immediate: true
    }
  },

  // 自定义方法
  methods: {
    handlerIsRows() {
      this.tagsWarpHeigh = this.$refs.tagsRef.clientHeight
      this.tagHeigh = this.$refs.vanTagRef[0].clientHeight
      if (this.tagsWarpHeigh > this.tagHeigh + 15) {
        this.showTagArrow = true
      }
      this.$refs.tagsRef.style.height = this.tagHeigh + 10 + 'px'
    },

    showAlltags() {
      this.showAlltagsFlag = !this.showAlltagsFlag
      if (this.showAlltagsFlag) {
        this.$refs.tagsRef.style.height = this.tagsWarpHeigh + 'px'
      } else {
        this.$refs.tagsRef.style.height = this.tagHeigh + 10 + 'px'
      }
    }
  },

  // 刚创建vue实例完毕
  created() {},

  // 刚挂载完毕
  mounted() {
  }
}
</script>
<style lang='scss' scoped>
.tags {
    position: relative;
    overflow: hidden;
    margin-left: 10px;
    transition: all .3s;
    // padding-top: 6px;
    margin-top: 2px;
    margin-bottom: 2px;
    .van-tag {
      margin-right: 8px;
      margin-bottom: 8px;
    }
    .tags-arrow {
      position: absolute;
      width: 22px;
      height: 22px;
      top: 1px;
      right: 10px;
      transition: all .3s;
    }
    .show-all-tags {
      transform: rotate(180deg);
    }
  }
.tags-hasarrow {
  padding-right: 29px;
}
</style>